import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { getHttpHeaders } from '../../../shared/utils/http.utils';
import { TokenStorageService } from './token-storage.service';

const baseUrl = environment.API_URL;

export interface OfficeTimezoneResponse {
  office_timezone: string | null;
  office_timezone_source: string | null;
}

/**
 * JOB-4193. Asks the API for the company's zone on every app load, so a zone
 * changed in Settings (or by moving the HQ) reaches sessions logged in before.
 */
@Injectable({
  providedIn: 'root'
})
export class OfficeTimezoneService {
  constructor(
    private http: HttpClient,
    private tokenStorageService: TokenStorageService
  ) {}

  public refresh(): void {
    if (!this.tokenStorageService.getToken()) {
      return;
    }
    this.http.get<OfficeTimezoneResponse>(`${baseUrl}/office-timezone`, {headers: getHttpHeaders()}).subscribe({
      next: (res) => this.tokenStorageService.saveOfficeTimezone(res?.office_timezone ?? null, res?.office_timezone_source ?? null),
      // The zone stored at login (or the browser's) still applies; nothing to show the office.
      error: (err) => console.warn('Could not refresh the office time zone', err?.status),
    });
  }
}
